import React from "react";
import styles from "./Button.module.scss";

const Button = ({
  label,
  variant = "contained",
  size = "medium",
  color = "primary",
  isLoading = false,
  disabled = false,
  fullWidth = false,
  startIcon,
  endIcon,
  onClick,
  type = "button",
  className = "",
  ...props
}) => {
  const buttonClasses = [
    styles.button,
    styles[`button--${variant}`],
    styles[`button--${variant}--${color}`], // Combined variant and color
    styles[`button--${size}`],
    fullWidth ? styles["button--full-width"] : "",
    isLoading ? styles["button--loading"] : "",
    className,
  ]
    .join(" ")
    .trim();

  return (
    <button
      className={buttonClasses}
      disabled={disabled || isLoading}
      onClick={onClick}
      type={type}
      {...props}
    >
      {isLoading && <span className={styles.loader}></span>}
      {startIcon && !isLoading && (
        <span className={styles.icon}>{startIcon}</span>
      )}
      {!isLoading && label}
      {endIcon && !isLoading && <span className={styles.icon}>{endIcon}</span>}
    </button>
  );
};

export default Button;
